export function createGuestUser(): User {
  const randomNumber = Math.floor(Math.random() * 1000000)
  return {
    isHost: false,
    userId: randomNumber,
    userName: `guest${randomNumber}`,
    displayName: `Guest ${randomNumber}`,
    userImage: '',
  }
}
